<template>
  <div
    class="flex min-w-0 flex-1 flex-col space-y-1"
    :data-cy="`offer-field-${props.offerField.name}`"
  >
    <div v-tooltipable class="truncate text-sm text-gray-400">
      {{ title }}
    </div>
    <div class="scrollbar-thin overflow-x-auto text-gray-600">
      <div class="whitespace-nowrap">{{ formattedValue }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { offerFieldFormatter } from "@/helpers/formatting";

import type { OfferFieldDetails } from "@/models/offers";

const props = defineProps<{
  offerField: OfferFieldDetails;
}>();

const formattedValue = computed(() => {
  if (props.offerField.value === null) {
    return "-";
  }
  return offerFieldFormatter[props.offerField.type](
    props.offerField.value,
    props.offerField.options
  );
});

const title = computed(() => {
  return props.offerField.label.trim() || "-";
});
</script>
